import React from 'react';
import PropTypes from 'prop-types';
export var SearchBoxNoResults = function SearchBoxNoResults(_ref) {
  var message = _ref.message;
  return React.createElement("ul", null, React.createElement("li", {
    className: "dropdown__item dropdown__item--no-results"
  }, message));
};
SearchBoxNoResults.propTypes = {
  message: PropTypes.string.isRequired
};